import {ReachSnippetLanguage, ReachSnippetSource} from "../../apis/requests/snippets/types";
import {ChipVariant} from "../templates/templateDisplay";

export const SNIPPET_SOURCE_DISPLAY: Record<ReachSnippetSource, {label: string; variant: ChipVariant}> = {
  manual: {label: "Manual", variant: "inherit"},
  cio_studio: {label: "Studio", variant: "yellow"},
  cio_regular: {label: "Campaign", variant: "pink"},
};

export const SNIPPET_LANGUAGE_LABELS: Record<ReachSnippetLanguage, string> = {
  en: "English",
  es: "Spanish",
};
